// extracted by mini-css-extract-plugin
export var chatHtmlText = "_it-2";
export var chatLink = "_it-0";
export var chatText = "_it-1";